import { render, staticRenderFns } from "./RptDelinquentResidents.vue?vue&type=template&id=5c744b07&scoped=true&"
import script from "./RptDelinquentResidents.vue?vue&type=script&lang=js&"
export * from "./RptDelinquentResidents.vue?vue&type=script&lang=js&"
import style0 from "./RptDelinquentResidents.vue?vue&type=style&index=0&id=5c744b07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c744b07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VRow,VTextField})
